import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  TComponentGroupUndoRequestDTO,
  TComponentGroupUndoResponseDTO,
  TComponentLineInTransactionRequest,
  TComponentLineInTransactionResponse,
  TComponentsGroupAddRequestDTO,
  TComponentsGroupAddResponseDTO,
  TTransactionDetailsRequestDTO,
  TTransactionDetailsResponse,
} from '@monorepo/types';

import { ComponentLineInEnvProvider } from './component-line-in.env.provider';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class ComponentLineInDataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private componentLineInEnvProvider: ComponentLineInEnvProvider) {}

  saveComponentTags(payload: TComponentsGroupAddRequestDTO): Observable<TComponentsGroupAddResponseDTO> {
    const URL = this.componentLineInEnvProvider.getEnvVar('SAVE_COMPONENT_TAGS');
    return this.http.post<TComponentsGroupAddResponseDTO>(URL, payload, this.httpOptions);
  }

  fetchTransactionLog(payload: TComponentLineInTransactionRequest): Observable<TComponentLineInTransactionResponse> {
    const URL = this.componentLineInEnvProvider.getEnvVar('FETCH_TRANSACTION_LOG');
    return this.http.post<TComponentLineInTransactionResponse>(URL, payload, this.httpOptions);
  }

  getTransactionDetails(payload: TTransactionDetailsRequestDTO): Observable<TTransactionDetailsResponse> {
    const URL = this.componentLineInEnvProvider.getEnvVar('TRANSACTION_DETAILS');
    return this.http.post<TTransactionDetailsResponse>(URL, payload, this.httpOptions);
  }

  undoComponentTags(payload: TComponentGroupUndoRequestDTO): Observable<TComponentGroupUndoResponseDTO> {
    const URL = this.componentLineInEnvProvider.getEnvVar('UNDO_COMPONENT_TAGS');
    return this.http.post<TComponentGroupUndoResponseDTO>(URL, payload, this.httpOptions);
  }
}
